import React from "react";

export default function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="#DFDFE6"
      />
      <path
        d="M9.17011 15.5801C8.98011 15.5801 8.79011 15.5101 8.64011 15.3601C8.35011 15.0701 8.35011 14.5901 8.64011 14.3001L14.3001 8.64011C14.5901 8.35011 15.0701 8.35011 15.3601 8.64011C15.6501 8.93011 15.6501 9.41011 15.3601 9.70011L9.70011 15.3601C9.56011 15.5101 9.36011 15.5801 9.17011 15.5801Z"
        fill="#23262F"
      />
      <path
        d="M14.8301 15.5801C14.6401 15.5801 14.4501 15.5101 14.3001 15.3601L8.64011 9.70011C8.35011 9.41011 8.35011 8.93011 8.64011 8.64011C8.93011 8.35011 9.41011 8.35011 9.70011 8.64011L15.3601 14.3001C15.6501 14.5901 15.6501 15.0701 15.3601 15.3601C15.2101 15.5101 15.0201 15.5801 14.8301 15.5801Z"
        fill="#23262F"
      />
    </svg>
  );
}
